import React from 'react';
import { roundNum } from 'utils/numbers';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';
import { confirmAlert } from 'react-confirm-alert';
import NutritionItem from '../NutritionItem';

const MealsList = props => {
  const { planId, meals, deleteMeal, history, plan } = props;

  const deleteCurrentMeal = (index) => {
    deleteMeal(plan, index, history);
  }

  const handleMealDeletion = (index) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure"
            text="Are you sure you want to delete this Meal?"
            cancelText="Cancel"
            confirmText="Delete"
            onClose={onClose}
            handleConfirming={() => deleteCurrentMeal(index)}
          />
        );
      }
    });
  };

  return (
    <ul className="meals-list">
      {meals.map((meal, index) => {
        return (
          <li key={index}>
            <NutritionItem
              title={meal.name}
              desc={`Protein: ${roundNum(meal.ingredients_protein)}g, Carbs: ${roundNum(meal.ingredients_carbs)}g, Fat: ${roundNum(meal.ingredients_fat)}g, Calories: ${roundNum(meal.ingredients_calories)}`}
              LinkTo={`/nutrition/${planId}/meals/${index}`}
              enableDelete={true}
              deleteMeal={handleMealDeletion}
              index={index}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default MealsList;
